module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl1-100.ec9d12bd.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl1-100.png
// module id = 3496
// module chunks = 11